import React, { useEffect, useState } from "react";

import Header from "../../components/header/";
import Footer from "../../components/footer/component";
import AppButton from "../../components/button/component";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import FunnelStepTypes from "../funnel-step/types";
import { useDispatch } from "react-redux";
import { trackEvents } from "../../utils/tracking-events";
import { getPortalCD, readCookie } from "../../utils/helpers";
import {
  addSpacesOnCaps,
  convertToLowerCase,
  getCountryCode,
  getImage,
  InvitationStatus,
  REPORT_ROUTES,
  getCookie,
} from "../../utils/utility-functions";
import {
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  PERSONALITY_TEST_ASSESSMENT_ID,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
} from "../../utils/general-config";
import { useTranslation } from "react-i18next";
import PathHelper from "../../utils/path-helper";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import "../../components/share-modal/component";
import ShareProfileModal from "../../components/share-modal/component";
import { CreateNewUserModel } from "../../components/model/component";

const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

const Confirmation = ({
  UpdateConfimationConnect,
  funnelStep,
  GetUserByIdConnect,
  DownloadAssessmentResultConnect,
  IsGuestOrPremiumUserConnect,
  ViewAssessmentReportConnect,
  updateUserConnect,
  createGuestUserWithoutEmailConnect,
  GuestUserChangesConnect,
  GetGuestUserConnect,
  GetBillingConnect,
  saveRelationshipCompatibilityResultConnect,
  saveUserAssessmentResultMapsConnect,
  isGuestOrPremiumUserConnect,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    userGUID,
    isConfirmationView,
    assessmentAttemptId,
    email,
    gender,
    assessmentId,
    countryCD: reduxCountryCD,
    currencyCD,
    assessmentMapId,
    isAuth,
    romanticCompatibilityParentUserId,
  } = funnelStep || {};
  const countryCD = getCountryCode(reduxCountryCD);
  const isRomanticCompatiblityTest =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);
  const romanticCompatibilityTestParentUserId =
    isRomanticCompatiblityTest && romanticCompatibilityParentUserId;
  const [isParentUserGuestOrPremium, setIsParentUserGuestOrPremium] =
    useState(false);

  // const token = localStorage.getItem("jwtToken");
  // const token = getCookie("jwtToken");
  // const dashboardAbTestValue = getCookie("dashboardAbTestValue");
  const [showFalsePlanModal, setShowFalsePlanModal] = useState(false);
  const [showInviteFriendModal, setShowInviteFriendModal] = useState(false);
  const [userData, setUserData] = useState(null);
  const [guestUserCount, setGuestUserCount] = useState(0);
  const [guestUserData, setGuestUserData] = useState([]);
  const [billingDetails, setBillingDetails] = useState(null);
  const [isPremiumOrGuest, setIsPremiumOrGuest] = useState(false);
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD_B, currentLocale);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    trackEvents("confirmationView", {
      userGuid: userGUID,
      email: email,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(currentLocale),
      gender: gender,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
    const disableBack = () => {
      window.history.forward();
    };

    const handleOnUnload = () => null;

    setTimeout(disableBack, 0);
    window.onunload = handleOnUnload;

    // Cleanup function
    return () => {
      window.onunload = null;
    };
  }, []);

  useEffect(() => {
    const isFalsePlan = getCookie("isFalsePlan");

    if (isFalsePlan === "true") {
      setShowFalsePlanModal(true);
    }
  }, []);

  useEffect(() => {
    if (userGUID) {
      GetUserByIdConnect(userGUID).then((res) => {
        if (res) {
          const fullName =
            res?.firstName || res?.lastName
              ? `${res.firstName} ${res.lastName}`
              : res?.userName;

          dispatch(
            PushUserInformationToFunnelStep({
              userGUID: res.userGuid,
              email: res?.email,
              accnum: res?.accountNumber,
              uname: fullName,
            }),
          );
          // createCookie("userguid", res?.userGuid, 1);
          // createCookie("uname", fullName, 1);
          // createCookie("accnum", res?.accountNumber, 1);
        }
      });
    }
  }, [userGUID]);

  const assessmentIDValue = assessmentId?.toLowerCase();
  const isPersonalityTest =
    assessmentIDValue === PERSONALITY_TEST_ASSESSMENT_ID;
  const queryParams = new URLSearchParams(location.search);
  const pt = queryParams.get("pt");
  const pn = queryParams.get("pn");
  const pg = isPersonalityTest === true ? queryParams.get("pg") : undefined;
  const assessmentGroup = queryParams.get("pg");
  const personalityNameEnglishCode = queryParams.get("pnes");

  const personalityImage = getImage(
    pg,
    personalityNameEnglishCode,
    true,
    gender,
  );

  const assessmentImage = getImage(
    assessmentGroup,
    personalityNameEnglishCode,
    true,
    gender,
  );

  useEffect(() => {
    if (isAuth) {
      // createCookie("avatarImg", personalityImage, 1);
      dispatch(
        PushUserInformationToFunnelStep({
          avatarImg: personalityImage,
        }),
      );
    }
  }, [isAuth, personalityImage]);

  useEffect(() => {
    if (!isAuth) {
      navigate(loginPath.next);
    }
  }, [isAuth]);

  const PushConfirmationViewToFunnelStep = (confirmationView) => ({
    type: FunnelStepTypes.SET_CONFIRMATION_VIEW,
    confirmationView,
  });
  useEffect(() => {
    if (
      romanticCompatibilityTestParentUserId &&
      romanticCompatibilityTestParentUserId !== null
    ) {
      isGuestOrPremiumUserConnect(romanticCompatibilityTestParentUserId).then(
        (res) => {
          if (res) {
            setIsParentUserGuestOrPremium(res?.isPremiumOrGuestUser);
          }
        },
      );
    }
  }, [romanticCompatibilityTestParentUserId]);

  useEffect(() => {
    if (!isConfirmationView && userGUID) {
      const data = {
        userGuid: userGUID,
      };
      UpdateConfimationConnect(data);
      dispatch(PushConfirmationViewToFunnelStep(true));
    }
  }, [userGUID, UpdateConfimationConnect, isConfirmationView]);

  const handleRomanticCompatibilityResultSaving = () => {
    if (
      isRomanticCompatibilityTest &&
      romanticCompatibilityTestParentUserId &&
      !isParentUserGuestOrPremium
    ) {
      saveRelationshipCompatibilityResultConnect(assessmentMapId).then(
        (res) => {
          if (!!res) {
            const resultId = res.userTraits[0]?.userAssessmentResultId;
            const payloadAssessmentResultMap = [
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: romanticCompatibilityTestParentUserId,
              },
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: userGUID,
              },
            ];
            saveUserAssessmentResultMapsConnect(
              payloadAssessmentResultMap,
            ).then((res) => {
              if (!!res) {
                const data = {
                  parentUserGuid: userGUID,
                  userGuid: romanticCompatibilityTestParentUserId,
                };
                updateUserConnect(data).then((res) => {
                  if (res) {
                    const { firstName, lastName, email } = res;
                    const guestUserPayload = {
                      id: romanticCompatibilityTestParentUserId,
                      firstName: firstName || "",
                      lastName: lastName || "",
                      emailAddress: email,
                      invitationStatus: InvitationStatus.Accepted,
                      parentId: userGUID,
                    };
                    createGuestUserWithoutEmailConnect(guestUserPayload).then(
                      (res) => {
                        if (res) {
                        }
                      },
                    );
                  }
                });
              }
            });
          }
        },
      );
    }
  };

  useEffect(() => {
    if (romanticCompatibilityTestParentUserId && !isConfirmationView) {
      handleRomanticCompatibilityResultSaving();
    }
  }, [romanticCompatibilityTestParentUserId, isConfirmationView]);

  const closeModal = () => {
    setOpen(false);
    navigate(dashboardPath.next);
  };
  const isEnneagramTest = assessmentIDValue === ENNEAGRAM_TEST_ASSESSMENT_ID;
  const isRomanticCompatibilityTest =
    convertToLowerCase(assessmentIDValue) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);

  const handleViewReport = () => {
    let reportRoute;
    if (isRomanticCompatibilityTest) {
      const romanticRoutes = REPORT_ROUTES[assessmentIDValue];
      reportRoute = romanticRoutes?.personal;
    } else {
      reportRoute = REPORT_ROUTES[assessmentIDValue];
    }
    const path = PathHelper(reportRoute, currentLocale);
    navigate(`${path.next}?uid=${userGUID}&aai=${assessmentAttemptId}`);
  };

  return (
    <>
      <div className="min-h-[100dvh] flex flex-col">
        <Header />
        <div className="flex-1 flex flex-col justify-center items-center p-5">
          <ShareProfileModal
            isOpen={showFalsePlanModal}
            onClose={() => setShowFalsePlanModal(false)}
            isFreeUpgrade={true}
            onInviteFriendsClick={() => {
              setShowFalsePlanModal(false);
              setShowInviteFriendModal(true);
            }}
          />

          <CreateNewUserModel
            isOpen={showInviteFriendModal}
            setOpen={setShowInviteFriendModal}
            parentId={userGUID}
            CreateGuestUserConnect={GuestUserChangesConnect}
            GetGuestUserConnect={GetGuestUserConnect}
            setGuestUserData={setGuestUserData}
            setGuestUserCount={setGuestUserCount}
            parentEmail={userData?.email}
            guestUserData={guestUserData}
            currentLocale={currentLocale}
            t={t}
            isPremiumOrGuest={isPremiumOrGuest}
            guestUserCount={guestUserCount}
            maxSubUserCount={billingDetails?.maxSubUserCount}
          />

          <h1 className="font-montserrat font-bold" style={{ fontSize: 35 }}>
            <span className="text-[#805AED] block md:inline">
              {t("dashboard.congratulations_text")},
            </span>
            <span className="text-[#444C5E] block md:inline text-[25px] lg:text-[35px]">
              {t("dashboard.your_report_ready_text")}
            </span>
          </h1>
          <img
            src={assessmentImage}
            alt="Report Ready"
            className="mx-auto mt-4"
            width={360}
            height={360}
          />
          {pn && pt && isPersonalityTest && (
            <>
              <p className="mt-4 text-[#805AED] text-lg">
                {t("dashboard.personality_type_label")} :
              </p>
              <h2 className="font-montserrat font-bold text-2xl">
                <span className="text-[#444C5E]">{pn} </span>
                <span className="font-normal text-[#805AED]">{pt}</span>
              </h2>
            </>
          )}

          {pn && pt && isEnneagramTest && (
            <>
              <p className="mt-4 text-[#805AED] text-lg">
                {t("dashboard.personality_type_message")}
              </p>
              <h2 className="font-montserrat font-bold text-2xl">
                <span className="text-[#444C5E]">{addSpacesOnCaps(pn)} </span>
              </h2>
            </>
          )}

          <div className="mt-4 flex flex-col items-center gap-3">
            {pn && pt && (
              <AppButton
                id="confirmation-view-report"
                className="py-2 px-4 border border-transparent rounded-full shadow-sm text-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 bg-[#FE6634] font-bold text-lg md:w-[300px] md:h-[63px]"
                onClick={() => {
                  // setOpen(true);
                  handleViewReport();
                }}
              >
                {t("dashboard.view_report_cta")}
              </AppButton>
            )}
            {/* <AppModel
            isOpen={open}
            onRequestClose={closeModal}
            DownloadAssessmentResultConnect={DownloadAssessmentResultConnect}
            assessmentAttemptId={assessmentAttemptId}
            userGUID={userGUID}
          /> */}

            <AppButton
              id="confirmation-go-to-dashboard-button"
              className="mx-auto text-black flex justify-center items-center text-center py-2 px-4 border border-transparent rounded-full shadow-sm text-medium hover:text-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 bg-[#D9D9D9] font-bold md:w-[300px] md:h-[63px] text-lg"
              onClick={() => {
                navigate(dashboardPath.next);
              }}
            >
              {t("dashboard.go_to_dashboard_cta")}
            </AppButton>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Confirmation;
